import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {
 
    },
    actions: {
        fetchCommandes(ctx, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .get('/api/commandes', { params: payload })
                    .then(response => resolve(response.data))
                    .catch(error => reject(error))
            })
        },
        
    },
}
